import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Circuit from '../views/Circuit.vue'
import Schedule from '../views/Schedule.vue'
import Meter from '../views/Meter.vue'
import Login from '../views/Login.vue'
import Map from '../views/Map.vue'
import MapConsumption from '../views/MapConsumption.vue'
import MapHumidity from '../views/MapHumidity.vue'
import MapLight from '../views/MapLight.vue'
import MapSignal from '../views/MapSignal.vue'
import MapTemps from '../views/MapTemps.vue'
import Main from '../views/Main.vue'
import StatusCircuit from '../views/StatusCircuit.vue'
import GroupMap from '../views/GroupMap.vue'
import Settings from '../views/Settings.vue'
import Alarms from '../views/Alarms.vue'
import { auth } from '../plugins/firebase'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
		component: Home,
		meta: {
            requiresAuth: true,
        },
	},
	{
		path: '/login',
		name: 'Login',
		component: Login
    },
    {
        path: '/map',
        name: 'Map',
        component: Map,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/mapconsumption',
        name: 'MapConsumption',
        component: MapConsumption,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/mapsignal',
        name: 'MapSignal',
        component: MapSignal,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/maphumidity',
        name: 'MapHumidity',
        component: MapHumidity,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/maplight',
        name: 'MapLight',
        component: MapLight,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/maptemps',
        name: 'MapTemps',
        component: MapTemps,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/circuit/:id',
        name: 'Circuit',
        component: Circuit,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/schedule/:id',
        name: 'Schedule',
        component: Schedule,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/meter/:id',
        name: 'Meter',
        component: Meter,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/main',
        name: 'Main',
        component: Main,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/statuscircuit/:id',
        name: 'StatusCircuit',
        component: StatusCircuit,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/groupmap/:id',
        name:'GroupMap',
        component: GroupMap,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/settings',
        name:'Settings',
        component: Settings,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/alarms',
        name:'Alarms',
        component: Alarms,
        meta: {
            requiresAuth: true,
        },
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
})

router.beforeEach((to, from, next) =>{
	const requiresAuth = to.matched.some( r => r.meta.requiresAuth )

	requiresAuth && !auth.currentUser
		? next('/login')
        : next()
        
})

export default router
